import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Ana Sayfa', path: '/' },
    { name: 'Sentinel', path: '/sentinel' },
    { name: 'Intune', path: '/intune' },
    { name: 'Microsoft EDR', path: '/edr' },
    { name: 'Projeler', path: '/projects' },
    { name: 'Etkinlikler', path: '/events' },
    { name: 'Hakkımda', path: '/about' },
  ];

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3 cursor-pointer">
            <img 
              src="https://public.readdy.ai/ai/img_res/31228f50-38f5-4c6b-86fc-ab24e41fc90e.png" 
              alt="Logo" 
              className="h-12 w-12 object-contain"
            />
            <span className={`text-xl font-bold transition-colors ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}>
              MS Security Labs
            </span>
          </Link>

          <div className="flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                  location.pathname === link.path
                    ? isScrolled
                      ? 'text-blue-600'
                      : 'text-white font-semibold'
                    : isScrolled
                    ? 'text-gray-700 hover:text-blue-600'
                    : 'text-white/90 hover:text-white'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;